// extracted by mini-css-extract-plugin
module.exports = {"Projects":"Projects_Projects__2_TFh"};